
import { NoseurObject } from "@rivtn/noseur";
import { Actor, SanitizedResponse } from "../BaseService";
import { PloutousBaseService } from "./PloutousBaseService";

export interface ILanguage {
    name: string;
    code: string;
    status: string;
    created_by: Actor;
    updated_by: Actor;
    created_at: string;
    updated_at: string;
    external_id: string;
}

export class LanguageService extends PloutousBaseService {

    protected static instance: LanguageService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!LanguageService.instance) LanguageService.instance = new LanguageService();
        return LanguageService.instance;
    }

    queryLanguages(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<ILanguage>> {
        return this.report(this.transport.get("/api/v1/language", { query: this.normalizeParams(params) }));
    }

    getLanguageByCode(code: string): Promise<SanitizedResponse<ILanguage>> {
        return this.report(this.transport.get(`/api/v1/language/code/${code}`, { cache: true, key: `LANGUAGE_${code}` }));
    }

    createLanguage(payload: any): Promise<SanitizedResponse<ILanguage>> {
        return this.report(this.transport.post(`/api/v1/language`, payload));
    }

    updateLanguage(payload: Partial<ILanguage>): Promise<SanitizedResponse<ILanguage>> {
        const id = payload.external_id; delete payload.external_id;
        return this.report(this.transport.patch(`/api/v1/language/${id}`, payload));
    }

    deleteLanguage(id: string): Promise<SanitizedResponse<ILanguage>> {
        return this.report(this.transport.delete(`/api/v1/language/${id}`));
    }

}
